/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getListingProductIdFromState,
  listListingVariantIdsForChannel,
} from './helpers/entityReadHelpers';
import { removeListing, removeListingVariant } from './helpers/entityAdapter';
import pruneDeletedListingRows from './helpers/pruneDeletedListingRows';
import { setSelectedChannelByProduct } from './helpers/uiAdapter';

export const deleteProductLiveSnapshot = createAsyncThunk(
  'products/deleteProductLiveSnapshot',
  async ({ productId, channelId }, { getState, extra: { Logger, Toast, sdk } }) => {
    try {
      const listingProductId = getListingProductIdFromState(getState().products, productId, channelId);

      if (!listingProductId) {
        throw new Error(`Listing not found for channel ${channelId}`);
      }

      await sdk.products.deleteListing(listingProductId);

      return { productId, channelId };
    } catch (error) {
      Toast(
        'Listing is not removed. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error removing live listing'), { error }, [
        'RemoveLiveListingFailed',
        { errorMessage: 'Listing is not removed on the backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(deleteProductLiveSnapshot.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(deleteProductLiveSnapshot.fulfilled, (state, { payload }) => {
      const { productId, channelId } = payload;
      state.isBusy = false;

      const listingProductId = getListingProductIdFromState(state, productId, channelId);
      const listingVariantIds = listListingVariantIdsForChannel(state, productId, channelId);

      listingVariantIds.forEach((listingVariantId) => {
        removeListingVariant(state, listingVariantId);
      });
      if (listingProductId) {
        removeListing(state, listingProductId);
      }
      pruneDeletedListingRows(state, {
        listingIds: listingProductId ? [listingProductId] : [],
        variantIds: listingVariantIds,
      });
      setSelectedChannelByProduct(state, productId, 'master');
    })
    .addCase(deleteProductLiveSnapshot.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot remove live listing';
    });
};
